import React from "react";
import CategoryNavigationSticky from "@components/Navigation/CategoryNavigationSticky";
import StickySidebar from "./sticky-sidebar";

export default class ReactStickySidebar extends React.Component {
    constructor(props) {
        super(props);
        this.updateSidebar = this.updateSidebar.bind(this);

    }
    componentDidMount() {
        //require("sticky-sidebar");
        this.initSidebar();

    }

    initSidebar() {
        if (this.sidebar) {
            this.sidebar.destroy();
        }
       
        this.sidebar = new StickySidebar(this.elementRef, { innerWrapperSelector: '.sidebar__inner', topSpacing: this.elementRef.offsetTop
            , bottomSpacing: 30 });
        //const config = { attributes: true, childList: true, subtree: true };
        //this.observer = new MutationObserver(this.updateSidebar);
        //this.observer.observe(this.elementRef, config);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        //console.log("componentDidUpdate", this.props.initTrigger, prevProps.initTrigger); 
        if (prevProps.initTrigger !== this.props.initTrigger) {
            this.updateSidebar(); 
            //this.initSidebar();
        }
        // else {

        //     this.updateSidebar();
        // }
    }

    componentWillUnmount() {
        this.sidebar.destroy();
        //this.observer.disconnect();
    }

    callback(mutationsList, observer) {
        this.updateSidebar();
        
    }

    updateSidebar() {
        //console.log("something was updated in filter side bar");
        if (this.sidebar) {
            this.sidebar.updateSticky();
        } 
 
        if(this.props.onSideBarUpdate) {
            this.props.onSideBarUpdate();
        }
    }

    render() {
        
        return (
            <div ref={el => this.elementRef = el} className="sidebar"><div className="sidebar__inner">
                <CategoryNavigationSticky callback={this.updateSidebar}
                                          
                                          showCategories={true}                          
                /></div></div>
        );
    }
}